export enum Role {
  root = "root",
  assessor = "assessor",
  manager = "manager",
  provider = "provider",
  kindergarten = "kindergarten",
  department = "department",
}

export enum RoleId {
  Root = 1,
  Assessor = 2,
  Manager = 3,
  Provider = 4,
  Kindergarten = 5,
  Department = 6,
}
